// Grid: the test card as a source, for shows. The Outputs test card draws locally on each output; this one goes through diffusion like any source.

export default {
	name: 'grid',
	label: 'Grid',
	description: 'Square grid of lines in stage units — a test card, or a drifting lattice',

	expose: {
		speed: {
			tip: 'How fast the grid drifts along its angle; negative reverses',
			step: 0.01,
			period: 0.73,
			initial: 1,
			minimum: -8,
			maximum: 8,
		},
		zoom: {
			tip: 'Zooms the whole grid',
			minimum: 0.25,
			maximum: 4,
		},
		angle: {
			tip: 'Rotation of the grid',
			initial: 0,
		},
		tilt: {
			tip: 'Straight down at 90; lower tips the grid away into the distance',
			initial: 90,
		},
		width: {
			tip: 'Thickness of the lines',
			initial: 0.75,
			minimum: 0.1,
			maximum: 20,
			step: 0.05,
		},
		spacing: {
			tip: 'Size of the squares between lines',
			initial: 24,
			minimum: 1,
			maximum: 100,
			step: 0.1,
		},
		pan: {
			tip: 'Slides the grid across the frame',
			initial: 0,
		},
		color: {
			tip: 'First palette colour',
			initial: '#33d6ff',
		},
		color_b: {
			label: 'Color 2',
			tip: 'Last palette colour',
			initial: '#2a1a7a',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 16,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 1,
		},
		wash: {
			tip: 'Scrolls the palette through the lines, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'The squares: their colour and opacity',
			initial: '#000000',
		},
	},

	lock: { cross: 1 },
	range: { cross: [0, 1], enclose: [0, 1] },
}
